import api from './api'

export default {

	register(payload) {
		return api.post('register', payload, { skipAuth: true })
	},

	login(payload) {
		return api.post('login', payload, { skipAuth: true })
	},

	refresh() {
		return api.post('refresh')
	},

	logout() {
		return api.post('logout')
	},

	/**
	 * Get Auth User profile
	 *
	 * @returns {Promise<any>} AxiosResponse
	 */
	profile() {
		return api.get('profile')
	},

	sendResetLinkEmail(payload) {
		return api.post('password/email', payload, { skipAuth: true })
	},

	resetPassword(payload) {
		return api.post('password/reset', payload, { skipAuth: true })
	},
}
